import React, { memo, ReactNode } from 'react';

import SimpleList from '@plasma/ui.display.simple-list';
import Button from '@plasma/ui.general.button';
import SearchInput from '@plasma/ui.input.search-input';
import Modal from '@plasma/ui.layout.modal';
import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';

import EditableTable from '../../components/edit-table';
import { supplierValue } from '../../components/supplierInfo';
import TopBarThemed from '../../components/top-bar-themed';
import itemDocumentFinderMasterColumns from '../../types/itemDocumentFInderMasterDatatype';
import useItemDocumentFinderHook from './item-document-finder.hook';
import * as styled from './item-document-finder.styles';
import themes from './themes';

export interface ItemDocumentFinderProps {
  children?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

type Props = ItemDocumentFinderProps & ThemeOverride;

function ItemDocumentFinder(props: Props) {
  const { children, className, style, size, themeMode } = props;

  const {
    t,
    dataForColumns,
    handleGoHome,
    search,
    nameSearch,
    setSearch,
    setnameSearch,
    clickedRow,
    setClickedRow,
    showModal,
    setshowModal,
    handleSelection,
    handleRowClick,
    codeModalTitle,
    showCodeModal,
    HandleCodeModalCancel,
    HandleModalCancel,
    dropdownOptions,
    handleDropdownChange,
    selectedValue,
    gridQuantity,
    setGridQuantity,
    quant,
    setQuant,
    handleOk,
    totalItems,
    area,
    zone,
    lineseqData,
    equipNameSet,
    consumeSet,
    handleDrawingModal,
    handleDrawingModalCancel,
    viewDrawing,
    differentCosumableCodeArray,
    usedProfilesForCode,
    usedEquipmentsForCode,
    descriptionForCode,
    filtData,
    iFrameSrc,
    handleUp,
    handleDown,
    handleSupplierInfoModal,
    handleSupplierInfoModalCancel,
    showSupplierInfoModal,
  } = useItemDocumentFinderHook(props);

  const tableHeadingStyles: React.CSSProperties = {
    borderLeft: '1px solid #ccc',
    padding: '8px',
    textAlign: 'left',
  };

  const handleQuantityChange = (index, newQuantity) => {
    // Validate new quantity to ensure it's within a certain range or meets any other requirements
    // For example, ensuring it's not negative or doesn't exceed a maximum value

    // Update the quantity in the gridQuantity array
    const updatedGridQuantity = [...gridQuantity];
    updatedGridQuantity[index] = newQuantity;

    // Update the state with the new gridQuantity
    setGridQuantity(updatedGridQuantity);
  };

  return (
    <ThemeProvider themes={themes} selectedSize={size} selectedMode={themeMode}>
      <styled.ItemDocumentFinder
        className={`item-document-finder ${className ?? ''}`.trim()}
        style={{ maxHeight: '78vh' }}
      >
        <TopBarThemed topHeading={t('item-and-document-finder')} />

        <div style={{ margin: '3vh 0 0 1.5vh', display: 'flex', justifyContent: 'center' }}>
          {search || nameSearch ? (
            <div
              style={{
                borderRight: '1px solid black',
                borderLeft: '1px solid black',
                borderRadius: '2px',
                backgroundColor: 'white',
                width: 'max-content',
                height: '2.5vh',
                color: '#0066cc',
                fontSize: '1.4vh',
                fontWeight: 'bold',
                padding: '0 1vh 0 1vh',
              }}
            >
              {`${t('total')} ${totalItems} ${t('item-found')}`}
            </div>
          ) : (
            ''
          )}
        </div>

        <div style={{ margin: '2vh 0 0 1.5vh' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginRight: '1vw' }}>
            <SearchInput
              placeholder={`${t('search')} ${t('consumable-code')} ${t('and-press-enter')}`}
              style={{ width: '17vw', marginRight: '15%' }}
              onSearch={(data) => {
                setSearch(data);
              }}
            />

            <SearchInput
              placeholder={`${t('search')} ${t('consumable-name')} ${t('and-press-enter')}`}
              style={{ width: '17vw', marginRight: '18%' }}
              onSearch={(data) => {
                setnameSearch(data);
              }}
            />
          </div>
        </div>

        <EditableTable
          tableData={dataForColumns}
          tableColumns={itemDocumentFinderMasterColumns()}
          hiddenColumns={[]}
          stillHiddenColumns={[]}
          showActions_ext={false}
          allowSelection
          saveReturnType={'row'}
          onlyAddableFields={[]}
          handleSelection={(rowIndex, rowData, event) => handleSelection(rowIndex, rowData, event)}
          // clearTheSelection={selectionClear}
        />

        <Modal
          title={`${t('consumable-code')} ${clickedRow}`}
          width={'60%'}
          okText={t('save')}
          cancelText={t('cancel')}
          visible={showModal}
          confirmLoading={!(filtData && filtData.length > 0)}
          onCancel={() => HandleModalCancel()}
          onOk={() => handleOk()}
          destroyOnClose
        >
          {filtData && filtData.length > 0 ? (
            <div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  background: 'linear-gradient(to top left, #f0f0f5, #33adff34)',
                  padding: '20px',
                  borderRadius: '5px',
                }}
              >
                <table style={{ border: '1px solid #ccc', marginLeft: '2px' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#eee' }}>
                      <th style={tableHeadingStyles}> Sl. No. </th>
                      <th style={tableHeadingStyles}> Area </th>
                      <th style={tableHeadingStyles}> Zone </th>
                      <th style={tableHeadingStyles}> Equipment Name </th>
                      <th style={tableHeadingStyles}> Consumable Name </th>
                      <th style={tableHeadingStyles}> Profile </th>
                      <th style={tableHeadingStyles}> Quantity </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filtData.map((item, index) => {
                      return (
                        <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#eee' }}>
                          <td style={{ cursor: 'pointer', padding: '8px', width: '3vw' }}>
                            <div>{item.lineseq}</div>
                          </td>
                          <td
                            style={{ borderLeft: '1px solid #ccc', cursor: 'pointer', padding: '8px', width: '15.5vw' }}
                          >
                            <div>{item.areaName}</div>
                          </td>
                          <td
                            style={{ borderLeft: '1px solid #ccc', cursor: 'pointer', padding: '8px', width: '15.5vw' }}
                          >
                            <div>{item.zoneName}</div>
                          </td>
                          <td
                            style={{ borderLeft: '1px solid #ccc', cursor: 'pointer', padding: '8px', width: '15.5vw' }}
                          >
                            <div>{item.equipmentName}</div>
                          </td>
                          <td
                            style={{ borderLeft: '1px solid #ccc', cursor: 'pointer', padding: '8px', width: '15.5vw' }}
                          >
                            <div>{item.consumableName}</div>
                          </td>
                          <td
                            style={{ borderLeft: '1px solid #ccc', cursor: 'pointer', padding: '8px', width: '25.5vw' }}
                          >
                            {item.productType}-{item.productDescription}
                          </td>
                          <td
                            style={{ borderLeft: '1px solid #ccc', cursor: 'pointer', padding: '8px', width: '5.5vw' }}
                          >
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                              <div
                                style={{
                                  backgroundColor: item.itemcount === 0 ? 'grey' : '#f0f5f5',
                                  borderTop: '1px solid black',
                                  borderBottom: '1px solid black',
                                  borderLeft: '1px solid black',
                                  borderRadius: '2px',
                                  borderTopLeftRadius: '8px',
                                  borderBottomLeftRadius: '8px',
                                  width: '1.5vw',
                                  height: '26px',
                                  color: item.itemcount === 0 ? 'white' : 'red',
                                  fontWeight: 'bold',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                {/* Display quantIndex state variable */}
                                {item.itemcount}
                              </div>

                              <div>
                                {/* Button component */}
                                <Button
                                  htmlType={'button'}
                                  prefixIcon={{ name: 'keyboard_arrow_up' }}
                                  style={{ width: '20px', height: '13px', borderLeft: 'none', borderBottom: 'none' }}
                                  type={'secondary'}
                                  onClick={() => {
                                    // handleQuantityChange(index, gridQuantity[index] + 1);
                                    handleUp(index, item.itemcount + 1);
                                  }}
                                />

                                <Button
                                  htmlType={'button'}
                                  prefixIcon={{ name: 'keyboard_arrow_down' }}
                                  style={{ width: '20px', height: '13px', borderLeft: 'none', borderTop: 'none' }}
                                  type={'secondary'}
                                  onClick={() => {
                                    handleDown(index, item.itemcount);
                                  }}
                                />
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '18px',
                background: 'linear-gradient(to top left, #f0f0f5, #33adff34)',
                padding: '3vw',
                borderRadius: '5px',
              }}
            >
              {`${t('no-data-available')} ${t('not-exist-in-cart')}`}{' '}
            </div>
          )}
        </Modal>

        <Modal
          title={`${t('consumable')} ${codeModalTitle} ${t('main-data')}`}
          width={'max-content'}
          cancelText={t('cancel')}
          visible={showCodeModal}
          footer={null}
          onCancel={() => HandleCodeModalCancel()}
          onOk={() => HandleCodeModalCancel()}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              background: 'linear-gradient(to top left, #f0f0f5, #33adff34)',
              padding: '15px 20px 20px 20px',
              borderRadius: '5px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '30px', marginTop: '20px' }}>
              <div
                style={{
                  width: '10vw',
                  fontWeight: 'bold',
                  marginRight: '52px',
                  fontSize: '15px',
                  border: '1px solid #75a3a3',
                  backgroundColor: '#f0f5f5',
                  padding: '5px 10px',
                  borderRadius: '5px',
                }}
              >
                {t('description')}
              </div>
              <div
                style={{
                  width: 'max-content',
                  fontWeight: 'bold',
                  marginRight: '5px',
                  padding: '5px',
                  backgroundColor: 'white',
                  borderRadius: '5px',
                  border: '1px solid #75a3a3',
                }}
              >
                {descriptionForCode}
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '30px' }}>
              <div
                style={{
                  width: '10vw',
                  fontWeight: 'bold',
                  marginRight: '40px',
                  fontSize: '15px',
                  border: '1px solid #75a3a3',
                  backgroundColor: '#f0f5f5',
                  padding: '5px 10px',
                  borderRadius: '5px',
                }}
              >
                {t('used-in')}
              </div>
              <SimpleList
                dataSource={usedEquipmentsForCode}
                style={{
                  overflowX: 'auto',
                  overflowY: 'auto',
                  maxHeight: '14.5vh',
                  width: '21vw',
                  borderColor: '#8b8b8c',
                  borderRadius: '5px',
                }}
                renderItem={(item) => (
                  <div
                    style={{
                      marginLeft: '10px',
                      marginTop: '5px',
                      display: 'flex',
                      padding: '2px',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                      <div
                        style={{
                          width: '19vw',
                          marginRight: '5px',
                          padding: '2px',
                          backgroundColor: 'white',
                          borderRadius: '5px',
                          border: '1px solid #75a3a3',
                        }}
                      >
                        {item.equipmentcode} : {item.zonecode} : {item.areacode}
                      </div>
                    </div>
                  </div>
                )}
                itemLayout="horizontal"
              />
            </div>

            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '30px' }}>
              <div
                style={{
                  width: '10vw',
                  fontWeight: 'bold',
                  marginRight: '40px',
                  fontSize: '15px',
                  border: '1px solid #75a3a3',
                  backgroundColor: '#f0f5f5',
                  padding: '5px 10px',
                  borderRadius: '5px',
                }}
              >
                {t('used-for-profiles')}
              </div>
              <SimpleList
                dataSource={usedProfilesForCode}
                style={{
                  overflowX: 'auto',
                  overflowY: 'auto',
                  maxHeight: '14.5vh',
                  width: '16.5vw',
                  borderColor: '#8b8b8c',
                  borderRadius: '5px',
                }}
                renderItem={(item) => (
                  <div
                    style={{
                      marginLeft: '10px',
                      marginTop: '5px',
                      display: 'flex',
                      padding: '2px',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                      <div
                        style={{
                          width: '14vw',
                          marginRight: '5px',
                          padding: '2px',
                          backgroundColor: 'white',
                          borderRadius: '5px',
                          border: '1px solid #75a3a3',
                        }}
                      >
                        {item.producttype} : {item.productdescription}
                      </div>
                    </div>
                  </div>
                )}
                itemLayout="horizontal"
              />
            </div>

            <div style={{ display: 'flex', margin: '3vh 0 0 0', gap: '2vw' }}>
              <Button title={t('drawing')} style={{ borderRadius: '5px' }} onClick={handleDrawingModal} />

              <Button
                title={'Supplier Info'}
                style={{ borderRadius: '5px' }}
                suffixIcon={{ name: 'info' }}
                onClick={handleSupplierInfoModal}
              />
            </div>
          </div>

          <Modal
            title={`${t('consumable')} ${codeModalTitle}`}
            style={{}}
            width={'80%'}
            cancelText={t('cancel')}
            visible={viewDrawing}
            footer={null}
            onCancel={() => handleDrawingModalCancel()}
            onOk={() => handleDrawingModalCancel()}
          >
            <iframe
              src={iFrameSrc}
              title="PDF"
              style={{ marginTop: '1vh', height: '70vh', width: '100%' }} // Set width to 100%
            />
          </Modal>

          <Modal
            title={`${t('Supplier Contact Info')}`}
            width={'38%'}
            cancelText={t('cancel')}
            visible={showSupplierInfoModal}
            footer={null}
            onCancel={() => handleSupplierInfoModalCancel()}
            onOk={() => handleSupplierInfoModalCancel()}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                background: 'linear-gradient(to top left, #f0f0f5, #33adff34)',
                padding: '15px 20px 20px 20px',
                borderRadius: '5px',
                width: '100%',
              }}
            >
              {supplierValue
                ?.filter((supplierItem) => supplierItem.field === 'Mechanical')
                .map((supplierItem, supplierIndex) => {
                  return (
                    <div
                      key={supplierIndex}
                      style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '30px', width: '100%' }}
                    >
                      <div
                        style={{
                          width: '20%',
                          fontWeight: 'bold',
                          marginRight: '40px',
                          fontSize: '15px',
                          border: '1px solid #75a3a3',
                          backgroundColor: '#f0f5f5',
                          padding: '5px 10px',
                          borderRadius: '5px',
                        }}
                      >
                        {supplierItem.field}
                      </div>

                      <SimpleList
                        dataSource={supplierItem.contact}
                        itemLayout="horizontal"
                        style={{
                          overflowX: 'auto',
                          overflowY: 'auto',
                          maxHeight: '14.5vh',
                          width: '100%',
                          borderColor: '#8b8b8c',
                          borderRadius: '5px',
                        }}
                        renderItem={(item) => (
                          <div
                            style={{
                              marginLeft: '10px',
                              marginTop: '5px',
                              display: 'flex',
                              padding: '2px',
                              alignItems: 'center',
                            }}
                          >
                            <div
                              style={{
                                width: '22vw',
                                marginRight: '5px',
                                padding: '2px',
                                backgroundColor: 'white',
                                borderRadius: '5px',
                                border: '1px solid #75a3a3',
                              }}
                            >
                              {/* Name: {item.name}, Email: {item.email}, Phone: {item.phone} */}
                              {item.email}
                            </div>
                          </div>
                        )}
                      />
                    </div>
                  );

                  // return (
                  // <div key={supplierIndex} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '30px', width: '100%' }}>
                  //   <div style={{width: '20%', fontWeight: 'bold', marginRight: '40px', fontSize: '15px', border: '1px solid #75a3a3', backgroundColor: '#f0f5f5', padding: '5px 10px', borderRadius: '5px' }}>
                  //     {supplierItem.field} {console.log('supplierItem', supplierItem)} :
                  //   </div>
                  //     <SimpleList
                  //       dataSource={supplierItem.contact}
                  //       style={{overflowX: 'auto', overflowY: 'auto', maxHeight:'14.5vh', width: '100%', borderColor: '#8b8b8c', borderRadius: '5px'}}
                  //       renderItem={(item) => (
                  //         <div style={
                  //                   {marginLeft: '10px',
                  //                   marginTop:'5px',
                  //                   display: 'flex',
                  //                   padding: '2px',
                  //                   alignItems: 'center'
                  //               }}>

                  //           <div style={{ display: 'flex', alignItems: 'flex-start'}}>

                  //             <div style={{width: '22vw', marginRight: '5px', padding:'2px', backgroundColor: 'white', borderRadius: '5px', border: '1px solid #75a3a3'}}>
                  //               Name: {item.name}, Email: {item.email}, Phone: {item.phone}
                  //             </div>
                  //           </div>
                  //         </div>

                  //         )}
                  //       itemLayout="horizontal"
                  //     />
                  // </div>
                  // )
                })}
            </div>
          </Modal>
        </Modal>
        {children}
      </styled.ItemDocumentFinder>
    </ThemeProvider>
  );
}

export default memo(ItemDocumentFinder) as unknown as typeof ItemDocumentFinder;
